import {sum} from 'ramda';

import {WorkshopOverviewTileState} from '../types/WorkshopOverviewTileConfig';

export const getWorkshopSectionTotal = (tiles: WorkshopOverviewTileState[]) =>
  sum(tiles.map((tileState) => tileState.count ?? 0));
